import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getJwtToken } from '../../Redux/AdminReducer/action';
import { useFetcher, useNavigate } from 'react-router-dom';
import { END_POINT } from '../../Redux/AdminReducer/action';
import axios from 'axios';
import { PLAN_SECTIONS } from '../../constants/planSections';

const fetchItems = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    return result;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log(error);

    toast.error('Something went wrong while fetching data');
  }
};


const createOrUpdateItem = async (data) => {
  try {
    const result = await axios.post(`${END_POINT}/admin/plan_config`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    toast.success('Details Updated');

  } catch (error) {
    throw error
  }
};

const initialFormData = {
  conslusion: '',
  purposeOfEnquiry: { Primary: '', sub: '' },
  reference: '',
  location: '',
  number: '',
  name: '',
  createdAt: '',
  createdTime: '',
};

const sections = PLAN_SECTIONS;


const Plans = () => {
  const [selected, setSelected] = useState({}); 
  const [plans, setPlans] = useState([]);

  const fetchData=()=>{
    setSelected([])
    fetchItems('admin/plan_config/').then(res => {
      setSelected(res?.data || []); 
    });
  }
  
  useEffect(() => {
    fetchItems('rpay/plans/').then(res => {
      setPlans(res?.data || []); 
    });
    fetchData()
  }, []);

  const handleSave = async () => {
    try {
      await createOrUpdateItem(selected)  
      fetchData()
    } catch (error) {
      toast.error(error?.response?.data||"could not update details") 
    }
  };


  const toggleCheckbox = (planId, section) => {
    setSelected(prev => {
      const prevSections = prev[planId] || []; // Initialize as empty array if undefined
      const sectionIndex = prevSections.indexOf(section);
      let newSections;

      if (sectionIndex > -1) {
        newSections = [
          ...prevSections.slice(0, sectionIndex),
          ...prevSections.slice(sectionIndex + 1)
        ];
      } else {
        // Section not selected, add it
        newSections = [...prevSections, section];
      }

      return {
        ...prev,
        [planId]: newSections
      };
    });
  };

  return (
    <div className="p-4 container mx-auto">
    <h2 className="text-2xl font-semibold mb-4">Plan Section Configuration</h2>
    <div
      className="overflow-x-auto border border-gray-300"
      style={{ maxHeight: '700px', overflowY: 'auto' }}
    >
      <table className="min-w-full border-collapse border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border border-gray-300 px-4 py-2 text-left w-32 sticky top-0 bg-gray-100 z-30">
              Section
            </th>
            {plans?.map(plan => (
              <th
                key={plan.id}
                className="border border-gray-300 px-4 py-2 text-center sticky top-0 bg-gray-100 z-30"
              >
                {plan.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
  {sections?.map(sectionObj => {
    const { label, value } = sectionObj;

    return (
      <tr key={value} className="hover:bg-gray-50">
        <td className="border border-gray-300 px-4 py-2 whitespace-nowrap">{label}</td>
        {plans?.map(plan => (
          <td
            key={plan.id}
            className="border border-gray-300 px-4 py-2 text-center whitespace-nowrap"
          >
            <input
              type="checkbox"
              checked={
                Array.isArray(selected[plan.plan_id]) &&
                selected[plan.plan_id].includes(value)
              }
              onChange={() => toggleCheckbox(plan.plan_id, value)}
              className="w-5 h-5 cursor-pointer"
            />
          </td>
        ))}
      </tr>
    );
  })}
</tbody>
      </table>
    </div>
    <div className="mt-4 flex justify-end">
        <button
          onClick={handleSave}
          className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600"
        >
          Save
        </button>
      </div>
  </div>
  
  );
};

export default Plans;
